import { CmpMemberDashboardAccessReturn } from '../../../../graphql/types';
import { RedirectUri } from '../../../enumStrings';

export const canUseMemberRoute = (route: string, access?: CmpMemberDashboardAccessReturn | null): boolean => {
  if (!access) return false;
  if (route === RedirectUri.memberInvoices) return access.cmpEnabled && access.canViewInvoices;
  if (access.cmpEnabled && !access.canManageProfile) return false;
  return true;
};
export const memberInvoiceIdentityKey = (userId: string, chamberId: string, memberId: string, contactId?: string | null): string =>
  JSON.stringify([userId, chamberId, memberId, contactId]);
